module.exports = __webpack_public_path__ + "static/media/Partner Portal - GBR Network - 27-05-2025 C.af5f517d.gif";